import {useMemo} from "react";
import dayjs from "dayjs";

export function useToday() {
    const hoy = parseInt(dayjs().format('DD'));

     // Re-run only when 'hoy' changes
    return useMemo(() => {
        const daysInM = dayjs().daysInMonth();

        if (hoy >= 9 && hoy <= 21) {
            //15
            return 15 - hoy;
        } else if (hoy >= 1 && hoy <= 8) {
            //30
            return -hoy + 1;
        } else if (daysInM === hoy) {
            return 1;
        } else {
            return (daysInM + 1) - hoy;
        }
    }, [hoy]);
}
